__webpack_require__.p = "/vinne-10mila-website/";